import React from 'react';
import { getLocaleDisplayNameWithEmoji } from 'src/components-bl/VisualEditor/components/Locale/get-locale-display-name-with-emoji';
import { SubTitle } from 'src/components-bl/VisualEditor/components/Locale/Locale.styles';
import {
  AvailableIcons,
  Icon,
  MenuItem,
  SelectOnChangeEvent,
  SelectType,
  Typography,
  TypographyType,
  TypographyVariant,
} from 'src/components-dummy';
import { LabelStyled, SelectStyled, TooltipStyled } from '../../CampaignSideBar.styles';

interface LocaleVariableSelectProps {
  locales: string[];
  defaultLocale: string;
  locale: string;
  onChange: (value: string) => void;
}

export const LocaleVariableSelect = ({
  locales,
  defaultLocale,
  locale,
  onChange,
}: LocaleVariableSelectProps) => {
  const localeOptions = locales
    .map(l => {
      const { displayName, locale: matchedLocale } = getLocaleDisplayNameWithEmoji(l);
      return {
        value: matchedLocale,
        text: displayName,
        isPrimary: matchedLocale === defaultLocale,
      };
    })
    .sort((a, b) => Number(b.isPrimary) - Number(a.isPrimary));

  const handleLocaleChange: SelectOnChangeEvent = event => {
    const selectedLocale = event.target.value;
    onChange(selectedLocale);
  };

  return (
    <>
      <LabelStyled>
        Locale Variable
        <TooltipStyled
          position='bottom center'
          value='Select the language and region for the email content. This controls formatting like currency, dates, and translations.'
        >
          <Icon name={AvailableIcons.TooltipQuestionmarkGray} />
        </TooltipStyled>
      </LabelStyled>
      <SelectStyled type={SelectType.Menu} value={locale} onChange={handleLocaleChange}>
        {localeOptions.map(({ value, text, isPrimary }) => (
          <MenuItem key={value} value={value}>
            <Typography type={TypographyType.Body} variant={TypographyVariant.MediumRegular}>
              {text}
            </Typography>
            {isPrimary && (
              <SubTitle type={TypographyType.Body} variant={TypographyVariant.SmallRegular}>
                {'\u00A0'}| Primary Locale
              </SubTitle>
            )}
          </MenuItem>
        ))}
      </SelectStyled>
    </>
  );
};
